module.exports = __webpack_public_path__ + "img/dt.e7d42b08.png";